import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import { SearchParamsProvider } from "./context/SearchParamsContext";



const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

// Consentimiento OneTrust
const ANALYTICS_CAT = 'C0002'; //ID cookies "Analytics"

function hasConsentFor(categoryId) {
  if (typeof window === 'undefined') return false;
  const groups = window.OptanonActiveGroups; // "C0002,C0004,..."
  return !!groups && String(groups).split(',').includes(categoryId);
}

function onConsentReady(cb) {
  // Se dispara cuando OneTrust está listo y en cada cambio
  // lo llamamos desde OptanonWrapper
  window.addEventListener('onetrust-consent-ready', cb);
  window.addEventListener('OneTrustGroupsUpdated', cb);
  return () => {
    window.removeEventListener('onetrust-consent-ready', cb);
    window.removeEventListener('OneTrustGroupsUpdated', cb);
  };
}

// Carga diferida de GTM tras consentimiento
function loadGTM(containerId) {
  if (window.__gtmLoaded) return;
  window.__gtmLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });

  const f = document.getElementsByTagName('script')[0];
  const j = document.createElement('script');
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId
        + (window.dataLayer && window.dataLayer !== 'dataLayer' ? '&l=dataLayer' : '');
  f.parentNode.insertBefore(j, f);
}

function initAnalyticsWhenAllowed() {
  // Solo carga GTM si Analytics está consentido
  if (hasConsentFor(ANALYTICS_CAT)) {
    loadGTM('GTM-NSR3BX3');
  }
}

// Intenta inmediatamente (por si OneTrust ya está listo) y suscríbete a cambios
if (typeof window !== 'undefined') {
  // Si OneTrust no se carga en este contexto, estas llamadas no harán nada y GTM no se inyectará.
  try {
    initAnalyticsWhenAllowed();
    onConsentReady(initAnalyticsWhenAllowed);
  } catch (_) {
    // Silencioso: sin OneTrust, no cargamos GTM.
  }
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SearchParamsProvider>
        <App />
      </SearchParamsProvider>
    </QueryClientProvider>
  </React.StrictMode>
);


/*const dataAnalytics =  () => {
    // Google Tag Manager
    // let dataLayer = [{

    // }];

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!=='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NSR3BX3');
    // End Google Tag Manager
  }

dataAnalytics();
*/
        

